import { render, staticRenderFns } from "./ConfirmPassword.vue?vue&type=template&id=4c73a655&scoped=true&"
import script from "./ConfirmPassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmPassword.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/authenticate/_confirm-pass.scss?vue&type=style&index=0&id=4c73a655&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c73a655",
  null
  
)

export default component.exports